module.exports = __webpack_public_path__ + "static/media/traycorp-manual-import1.df08f0ec.png";